export default __webpack_public_path__ + "static/media/supercoin.5fce5ae7.png";